import axios from 'axios';
import { GUID } from '@utils/AppConstants';
import { ApiResponseDto } from '@utils/Models';
import type {
    ActivePopupModel,
    PopupDetailModel,
    SavePopupRequest,
} from './announcements.models';
import {
    ApiUrl_Popups_ActiveForCurrentUser,
    ApiUrl_Popups_MarkAsRead,
    ApiUrl_Popups_Get,
    ApiUrl_Popups_Create,
    ApiUrl_Popups_Update,
    ApiUrl_Popups_SetActive,
    ApiUrl_Popups_Delete,
} from '@utils/Endpoints';

export const popupsApi = {
    getActivePopups(): Promise<ActivePopupModel[]> {
        return axios
            .get<ApiResponseDto<ActivePopupModel[]>>(ApiUrl_Popups_ActiveForCurrentUser)
            .then((r) => r.data.Result);
    },

    markPopupAsRead(guid: GUID): Promise<void> {
        return axios
            .post<ApiResponseDto<void>>(ApiUrl_Popups_MarkAsRead(guid))
            .then(() => undefined);
    },

    getPopup(guid: GUID): Promise<PopupDetailModel> {
        return axios
            .get<ApiResponseDto<PopupDetailModel>>(ApiUrl_Popups_Get(guid))
            .then((r) => r.data.Result);
    },

    createPopup(request: SavePopupRequest): Promise<PopupDetailModel> {
        return axios
            .post<ApiResponseDto<PopupDetailModel>>(ApiUrl_Popups_Create, request)
            .then((r) => r.data.Result);
    },

    updatePopup(guid: GUID, request: SavePopupRequest): Promise<PopupDetailModel> {
        return axios
            .put<ApiResponseDto<PopupDetailModel>>(ApiUrl_Popups_Update(guid), request)
            .then((r) => r.data.Result);
    },

    setPopupActive(guid: GUID, isActive: boolean): Promise<void> {
        return axios
            .post<ApiResponseDto<void>>(ApiUrl_Popups_SetActive(guid), { IsActive: isActive })
            .then(() => undefined);
    },

    deletePopup(guid: GUID): Promise<void> {
        return axios
            .delete<ApiResponseDto<void>>(ApiUrl_Popups_Delete(guid))
            .then(() => undefined);
    },
};
